// extracted by mini-css-extract-plugin
export default {"subHeader":"UserProfileView-module__subHeader--JwwXg","iconContainer":"UserProfileView-module__iconContainer--MREf0"};